import PropTypes from 'prop-types'
import cn from '../modules/cn'

function FloatingAddon({
  children,
  addon,
  className,
  addonClassName,
}) {
  return (
    <div className={cn('relative inline-block', className)}>
      {addon && (
        <div
          className={cn(
            'absolute -right-1.5 -top-1.5',
            addonClassName,
          )}
        >
          {addon}
        </div>
      )}
      {children}
    </div>
  )
}

FloatingAddon.propTypes = {
  children: PropTypes.node.isRequired,
  addon: PropTypes.node,
  className: cn.propType,
  addonClassName: cn.propType,
}

FloatingAddon.defaultProps = {
  addon: null,
  className: null,
  addonClassName: null,
}

export default FloatingAddon
